import Finance from "@/pages/finance/Finance";
// Payables reuses the full Finance UI (Invoices / Payments / Notes / Ledger / Aging) but scoped to AP.
export default function FinancePayables() {
  return <Finance kind="PAYABLES" />;
}
